<template>
    <!--Waiting List Modal-->
    <div class="modal fade waiting-list-modal" :id="id" tabindex="-1" role="dialog" :aria-labelledby="id + 'Label'"
        aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" :id="id + 'Label'">
                        {{ title }}
                    </h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">×</span>
                    </button>
                </div>
                <div class="modal-body">
                    <p v-if="p1" v-html="p1"></p>
                    <p v-if="p2" v-html="p2"></p>
                    <p v-if="p3" v-html="p3"></p>
                    <p v-if="p4" v-html="p4"></p>

                </div>
                <div class="modal-footer">
                    <div class="enroll-btn">
                        <button @click="handleActionModal" type="button" class=" primary-btn extra-small mobile"
                            data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">{{ buttonText }}</span>
                        </button>
                        <button v-if="removeClient || cancelSubscription || cancelWaitlistClient" type="button"
                            class="secondary-btn small mobile" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">{{ buttonText2 }}</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    props: {
        id: {
            type: String,
            required: true,
        },
        title: {
            type: String,
            required: true,
        },
        p1: {
            type: String,
        },
        p2: {
            type: String,
        },
        p3: {
            type: String,
        },
        p4: {
            type: String,
        },
        buttonText: {
            type: String,
        },
        buttonText2: {
            type: String,
        },
        removeClient: {
            type: Boolean,
        },
        cancelSubscription: {
            type: Boolean,
        },
        cancelWaitlistClient: {
            type: Boolean,
        }
    },
    data() {
        return {};
    },
    computed: {},
    mounted() {},
    methods: {
        handleActionModal() {
            if(this.cancelSubscription) {
                this.$emit("cancel-subscription")
            }

            if(this.removeClient) {
                this.$emit("remove-client")
            }

            if (this.cancelWaitlistClient) {
                this.$emit("cancel-waitlist-client")
            }
        },
    },
};
</script>
